<div [class.show]="show" class="loader-overlay step">
  <div class="spinner-border text-info" role="status">
    <span class="sr-only">Loading...</span>
  </div>
</div>
